/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import LanguageSwitcherPopup from './LanguageSwitcherPopup';
import LanguageUtil from '../util/LanguageUtil';
export default (() => {
  const userLanguage = LanguageUtil.getPrintUserLanguage();
  const [popupOpen, setPopupOpen] = useState(false);
  const popup = useRef(null);

  const onClick = () => {
    setPopupOpen(true);
  };

  const onClickedOutside = () => {
    setPopupOpen(false);
  }; // handles onBlur properly so we don't intercept the anchor tag clicks


  useEffect(() => {
    const handleClickOutside = event => {
      if (popup.current && !popup.current.contains(event.target)) {
        onClickedOutside();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popup]);
  return /*#__PURE__*/_jsx("div", {
    className: "language-switcher-container",
    children: /*#__PURE__*/_jsxs("div", {
      ref: popup,
      className: "language-switcher",
      tabIndex: "0",
      onClick: onClick,
      children: [userLanguage, /*#__PURE__*/_jsx("span", {
        className: "icon icon-angle-down"
      }), /*#__PURE__*/_jsx(LanguageSwitcherPopup, {
        isOpen: popupOpen
      })]
    })
  });
});